<template>
  <el-dialog
    :title="$t('housekeepingFeeType.deleteTitle')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align:center">
      <p>{{ $t('housekeepingFeeType.deleteConfirm') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="deleteHousekeepingFeeType">{{ $t('common.confirmDelete') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { deleteHousekeepingFeeType } from '@/api/housekeeping/housekeepingFeeTypeApi'

export default {
  name: 'DeleteHousekeepingFeeType',
  data() {
    return {
      dialogVisible: false,
      deleteHousekeepingFeeTypeInfo: {}
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.deleteHousekeepingFeeTypeInfo = { ...row }
    },
    handleClose() {
      this.deleteHousekeepingFeeTypeInfo = {}
    },
    async deleteHousekeepingFeeType() {
      this.deleteHousekeepingFeeTypeInfo.shopId = getShopId()
      try {
        await deleteHousekeepingFeeType(this.deleteHousekeepingFeeTypeInfo)
        this.$message.success(this.$t('common.submitSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        this.$message.error(error)
        console.error('删除失败:', error)
      }
    }
  }
}
</script>